//  Copyright (c) 2021 First Foundry Inc. All rights reserved.

export const PATH = 'alerts'
export const SET_MESSAGE = `${PATH}/SET_MESSAGE`
